import http from '../require'
export const schoolPage = data => http.post('/v1/health/web/school/page', data)
export const loginSchoolPage = data => http.post('/v1/health/web/school/login_page', data)
export const foodTree = data => http.post('/v1/health/web/nutrition_plan/tree', data)
export const getLatest = data => http.post('/v1/health/web/nutrition_plan/get_latest', data)
